<template>
<div class="chapter">
<div class="inner_page">
<div> <a id="lpn_iii"></a></div>
<h1 class="title">TO THE RIVER</h1>
<p class="subtitle">A Journey Beneath the Surface</p>
<h4 class="author">OLIVIA LAING</h4>
<p class="logo"><img alt="" height="95" src="html/docimages/logo.jpg" width="207"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002_tp.vue?2581f292